import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import {
  SamplingPointsModel,
  EquipmentModel,
  AreaModel,
} from "../../../common/viewModels/GlobalRegistry/SampPointModel";
import { ValidationService } from "../../../common/validationservice";
import { MainAppComponent } from "../../../layout/layout.component";
import { CustomerModel } from "../../../common/viewModels/Admin/CustomerModel";
import "rxjs/add/operator/map";

@Component({
  selector: "addeditequipment",
  templateUrl: "./addeditspid.component.html",
  styleUrls: ["./addeditspid.component.scss"],
})
export class AddEditSPID implements OnInit {
  mainComponent: any;
  addSPIDForm: FormGroup;
  lstOilGrades: any;
  lstComponents: any;
  lstGraphTemplates: any;
  lstShips: any;
  customers: CustomerModel[];
  sampPoints: SamplingPointsModel[];
  equipments: EquipmentModel[];
  areas: AreaModel[];
  isSubmitted: boolean = false;
  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService
  ) {
    this.mainComponent = _mApp;
  }
  ngOnInit() {
    this.addSPIDForm = this._formBuilder.group({
      SpidId: [0],
      SpidNumber: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(20),
        ]),
      ],
      CustomerId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      MakeOfEquipment: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      ModelOfEquipment: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      EquipmentSrNo: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      EquipmentName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      SamplingPointId: [0],
      ComponentId: [0],
      GraphTemplateTypeId: [0],
      OilGradeId: [0],
      AreaId: [0],
      ShipId: [
        0,
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      TransformerDetails: [""],
      TransformerCapacity: [""],
      VoltageRating: [""],
      TransformerMake: [""],
      TransformerSerialNo: [""],
      YearOfMake: [""],
    });
    this.GetOilGrades();
    this.GetAreas();
    this.GetComponents();
    this.GetCustomers();
    this.GetGraphTemplates();
    this.GetSamplingPoints();
    this.GetShips();
    let id = this._route.snapshot.params["id"];
    if (id != null && id != "" && id != undefined) {
      this.GetSpIdById(id);
    } else {
      this.GetMaxSPIDValue();
    }
  }

  GetOilGrades() {
    this._http.get(this._appUrl.GetOilGradesForDDL).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstOilGrades = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetComponents() {
    this._http.get(this._appUrl.GetComponentMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstComponents = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetGraphTemplates() {
    this._http.get(this._appUrl.GetGraphTempleteTypeList).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstGraphTemplates = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.customers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetSamplingPoints() {
    this._http.get(this._appUrl.GetSampPointsMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.sampPoints = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetAreas() {
    this._http.get(this._appUrl.GetAreaMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.areas = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetShips() {
    this._http.get(this._appUrl.GetShipMinInfoList).subscribe(
      (data) => {
        var res = data.json().Result;
        if (res != null && res != undefined) this.lstShips = res;
      },
      (error) => {
        this._toastrService.error(error.json());
      }
    );
  }

  GetSpIdById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetSpIdById + id).subscribe(
      (m) => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.addSPIDForm.setValue(m.json().Result);
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
      }
    );
  }
  GetMaxSPIDValue() {
    this._http.get(this._appUrl.GetMaxSPIDValue).subscribe(
      (data) => {
        if (data.json().Result != null && data.json().Result != "") {
          var maxNo = Number(data.json().Result);
          maxNo = maxNo + 1;
          this.addSPIDForm.controls["SpidNumber"].setValue(maxNo);
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      }
    );
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.addSPIDForm.valid) {
      let spIdDetails = this.addSPIDForm.value;
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.UpsertSpId, spIdDetails).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, "");
          this._router.navigate(["/equipments"]);
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        }
      );
    } else {
    }
  }
}
